<div *ngIf="breadcrumbs.length > 0" class="pcs-breadcrumb d-flex py-3 justify-content-center align-items-center w-100 mt-0">
  <span class="d-flex align-items-center" *ngFor="let link of breadcrumbs ; let last=last">
    <a [routerLink]="link.url" [queryParams]="link.queryParams" [fragment]="link.fragment"> {{ link.text }} </a>
    <app-vficon
      class="icon d-flex px-2"
      *ngIf="!last"
      iconPack="source-system-icons"
      iconName="chevron-right"
    ></app-vficon>
  </span>
</div>
